<template>
  <div>
    <ed-table
      registerName="Inserir Novo GHE"
      :onRegister="onRegister"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :onSearch="getLtcat"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
    />
    <Editar :parent="this" />
    <Cadastrar :parent="this" />
  </div>
</template>

<script>
import EdTable from "common/table";
import Rest from "common/rest";
import Fct from "common/fct";
import Editar from "./editar";
import Cadastrar from "./cadastrar";

export default {
  name: "ltcat",
  components: { EdTable, Editar, Cadastrar },
  mixins: [Rest],
  props: {
    ltcat: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "$store.state.ltcat.data.id"() {
      this.getLtcat();
    },
    "$store.state.common.event"() {
      this.getLtcat();
    },
  },
  data() {
    return {
      pagination: {},
      response: {},
      formData: {},
      tableHead: [
        {
          key: "ordem",
          width: "50px",
          sortable: true,
          show_fdt: true,
          label: "Ordem",
        },
        {
          key: "ghe",
          sortable: true,
          show_fdt: true,
          label: "GHE (Setor)",
        },
        {
          key: "medicoes",
          sortable: true,
          show_colapse: true,
          label: "Medições",
        },
        {
          key: "funcoes",
          sortable: true,
          show_colapse: true,
          label: "Funções",
        },
        {
          key: "funcionarios",
          sortable: true,
          show_colapse: true,
          label: "Funcionários",
        },
        {
          key: "conclusoes",
          sortable: true,
          show_colapse: true,
          label: "Conclusão Técnica",
        },
        // {
        //     key: 'obs',
        // 	sortable: true,
        // 	show_colapse:true,
        // 	label: 'Observações',
        // },
        {
          key: "updated_at",
          width: "180px",
          sortable: true,
          show_user: true,
          label: "Atualização",
        },
      ],
      tableData: [],
      loadingTable: true,
      showFormEdit: false,
      showFormCadastro: false,
    };
  },
  beforeDestroy() {
    this.tableData = [];
    this.formData = {};
  },
  created() {},

  mounted() {
    this.getLtcat();
  },

  methods: {
    onRegister() {
      this.formData = {
        id: 0,
        copiar: null,
        ghes: [],
      };
      this.showFormCadastro = !this.showFormCadastro;
    },

    onEdit(data) {
      this.formData = {
        id: data.id,
        ordem: data.ordem,
        ghe: data.ghe,
        descricao: data.descricao,
        copiar: null,
        updated_at: data.updated_at,
        usuario: data.usuario,
        funcoes: data.funcoes,
        medicoes: data.medicoes,
        conclusoes: data.conclusoes,
        funcionarios: data.funcionarios,
        obs: data.obs,
        ordenar: 0,
      };
      this.showFormEdit = !this.showFormEdit;
    },

    onDelete(data) {
      var self = this;

      this.$confirm(
        "O sistema vai excluir " +
          data.length +
          " registro(s). Deseja prosseguir?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        self.loadingEditAll = true;
        self.loadingTable = true;

        this.post(
          "/ltcat/ghe/" + this.$store.state.ltcat.data.id + "/deletar",
          { ids: data }
        ).then((result) => {
          result = result[0];

          self.loadingEditAll = false;

          if (result.status == 200) {
            self.getLtcat();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    getLtcat(_search, _page, _pagination) {
      this.loadingTable = true;
      this.response = {};

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search,
        page: _page,
        pagination: _pagination,
      }).then((result) => {
        result = result[0];
        this.response = result;
        this.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
            tableData = [],
            self = this,
            pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var funcoes = "",
              funcionarios = "",
              medicoes = "",
              conclusoes = "";

            for (let j = 0; j < data[i].funcoes.length; j++) {
              const element = data[i].funcoes[j];
              funcoes += "<li>" + element.funcao.nome + "</li><br>";
            }

            for (let j = 0; j < data[i].funcionarios.length; j++) {
              const element = data[i].funcionarios[j];
              funcionarios += "<li>" + element.funcionario.nome + "</li><br>";
            }

            for (let j = 0; j < data[i].medicoes.length; j++) {
              const element = data[i].medicoes[j];
              medicoes +=
                "<li>" +
                (element.data_medicao
                  ? this.toDate(element.data_medicao, true) + ": "
                  : "") +
                element.fator_risco.nome +
                "</li><br>";
            }

            for (let j = 0; j < data[i].conclusoes.length; j++) {
              const element = data[i].conclusoes[j];
              conclusoes +=
                "<li>" +
                element.nome +
                "<br>" +
                element.descricao +
                "</li><br>";
            }

            var item = {
              ordem: data[i].ordem,
              ghe: data[i].ghe + " (" + data[i].descricao + ")",
              funcoes: funcoes,
              funcionarios: funcionarios,
              conclusoes: conclusoes,
              medicoes: medicoes,
              obs: data[i].obs
                ? data[i].obs.replace(/(?:\r\n|\r|\n)/g, "<br>")
                : "",
              updated_at: this.toDate(data[i].updated_at),
              _data: data[i],
              options: {
                disable_delete: !this.validarPermissao(567),
                disable_edit: !this.validarPermissao(567),
              },
              buttons: [],
            };
            tableData.push(item);
          }

          this.pagination = pagination;
          this.tableData = tableData;
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// index.vue?c8a8402a